import { render, staticRenderFns } from "./SignedDocumentsList.vue?vue&type=template&id=15a63347"
import script from "./SignedDocumentsList.vue?vue&type=script&lang=js"
export * from "./SignedDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./SignedDocumentsList.vue?vue&type=style&index=0&id=15a63347&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports